import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getOfertaDetPanel = async (searchAofId,searchArtId,page, perPage) => {
    let queryParams = [];
    if (searchAofId) {
      queryParams.push(`ofcab_id=${encodeURIComponent(searchAofId)}`);
    } 
    if (searchArtId) {
      queryParams.push(`art_Id=${encodeURIComponent(searchArtId)}`);
    }
       if (page) {
      queryParams.push(`page=${encodeURIComponent(page)}`);
    }
    if (perPage) {
      queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  
    return await getData("/ofertasdet/busqueda_panel_ofcab", queryString);
  }

export const getOfertaDetById = async (id) => {
    const res = await getData(`/ofertasdet/${id}`)
    return res
}

export const postOfertaDet = async (body) => {
    const res = await postData('/ofertasdet', body)
    return res
}

export const patchOfertaDet = async (id, body) => {
    const res = await patchData(`/ofertasdet/${id}`, body)
    return res
}

export const deleteOfertaDet = async (id) => {
    const res = await deleteData(`/ofertasdet/${id}`)
    return res
}

export const getArticulos = async () => {
    const res = await getData('/articulos');
    return res
}

export const getArticuloById = async (id) => {
    const res = await getData(`/articulos/${id}`)
    return res
}